import { useEffect } from 'react';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import HowItWorks from './components/HowItWorks';
import Modules from './components/Modules';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import DiagnosticForm from './components/DiagnosticForm';
import CTA from './components/CTA';
import { useSEO, generateOrganizationSchema, generateServiceSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  // SEO Configuration
  useSEO({
    title: 'LBAs Essentials - Consultoria em Processos para MEI e Pequenas Empresas',
    description: 'Transforme seu MEI ou pequena empresa com o LBAs Essentials. Programa de 10-12 meses focado em produtividade, organização e eficiência operacional com diagnóstico gratuito, acompanhamento mensal e resultados garantidos para melhoria de processos empresariais.',
    keywords: 'consultoria MEI, melhoria de processos, pequenas empresas, consultoria empresarial, eficiência operacional',
    canonical: '/',
    ogTitle: 'LBAs Essentials - Consultoria em Processos para MEI e Pequenas Empresas',
    ogDescription: 'Transforme seu negócio em 10-12 meses com metodologia comprovada. Ganhe até 40% mais produtividade com consultoria especializada em melhoria de processos.',
    ogType: 'website',
  });

  // Add Organization and Service Schema
  useEffect(() => {
    const organizationSchema = generateOrganizationSchema();
    const serviceSchema = generateServiceSchema();

    const combinedSchema = {
      '@context': 'https://schema.org',
      '@graph': [organizationSchema, serviceSchema],
    };

    let script = document.querySelector('script[type="application/ld+json"]#organization-schema');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('id', 'organization-schema');
      document.body.appendChild(script);
    }
    script.textContent = JSON.stringify(combinedSchema);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]#organization-schema');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <main>
      <Hero />
      <Benefits />
      <HowItWorks />
      <Modules />
      <Pricing />
      <Testimonials />
      <FAQ />
      <DiagnosticForm />
      <CTA />
    </main>
  );
}
